import script from "./RecordList.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecordList.vue?vue&type=script&setup=true&lang=ts"

import "./RecordList.vue?vue&type=style&index=0&id=73331225&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73331225"]])

export default __exports__